module.exports = __webpack_public_path__ + "static/mysql-64db31a8ce09463074400e6188c1505d.png";